import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


export const ContactUsPageContainer = styled.div`
  font-family: "Outfit", sans-serif;

  .contact_us_form {
    padding: 100px 0;
  }

  /* ========= LEFT SECTION ========= */
  .contact_us-content {
    padding: 0;
  }

  .contact_us-content h2,
  .contact_us-content h4,
  .contact_us-content p {
    margin-bottom: 20px;
  }

  .contact_list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .contact_list li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    color: #021e40;    
    margin-bottom: 20px;
    font-weight: 700;
  }

  .contact_list .icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .contact_list .social_icons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .social_links {
    display: flex;
    gap: 14px;
    margin-top: 4px;
  }

  /* Divider between phone/email/social */
  .contact_list li:not(:last-child) {
    padding-bottom: 12px;
  }

  /* ========= RIGHT SECTION ========= */
    .contact_us-form-data {
        padding-left: 100px !important;
    }

.contact_us-form-data label {
    display: block;
    margin-bottom: 12px;
    color: #333333;
    font-weight: 300;
}
  .contact_us-form-data input::placeholder,
  .contact_us-form-data textarea::placeholder,
  .contact_us-form-data select::placeholder {
    color: #808080;
     font-family: "Outfit", sans-serif !important;
    font-weight: 300;
  }
  .contact_us-form-data input,
  .contact_us-form-data textarea {
    width: 100%;
    height: 48px;
    padding: 0 14px;
    border: 0.5px solid #e5e5e5;
    border-radius: 10px;
    background: #f7f7f7;
    color: #808080;
    outline: none;
    transition: border-color 0.2s ease;
         font-family: "Outfit", sans-serif !important;
  }

  .contact_us-form-data textarea {
    height: auto;
    min-height: 120px;
    padding: 12px 14px;
         font-family: "Outfit", sans-serif !important;
    resize: vertical;
  }

  .contact_us-form-data input:focus,
  .contact_us-form-data textarea:focus {
    border-color: #c0c0c0;
  }

  .mygrid-row {
    margin-bottom: 0px;
  }

  .error {
    display: block;
    margin-top: 6px;
    font-size: 13px;
    color: red;
  }

  /* ========= SUBMIT ROW ========= */
  .form_submit_section .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .anti_spam_note {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #021e40;
    max-width: 60%;
  }

  .anti_spam_note .icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
    .social_icons_contact h4 {
        color: #021e40;
        font-weight: 600;
        font-size: 22px;
    }

    .social_icons_contact ul.social_links {
        padding: 0;
        list-style: none;
    }

    .social_icons_contact {
        border-top: 1px solid #A1A0A080;
        max-width: 499px;
        padding-top: 20px;
    }

.contact_list li a {
 color: #021E40;
    text-decoration: none;
}
.contact_list li a:hover {
   color: #EE2D2F;
    text-decoration: none;
}
ul.social_links li a:hover {
    opacity: 0.8;
}
@media (max-width: 1199px) {
    .contact_us-form-data {
        padding-left: 0px !important;
    }
    .contact_us-form-data {
        padding-top: 30px;
    }
    .social_icons_contact {
        max-width: 100%;
    }
}

@media (max-width: 991px) {
    .contact_us_form {
        padding: 60px 0;
    }
    .contact_us-form-data label {
      font-size: 14px;
      margin-bottom: 5px !important;
  }
}


`;
